<voxel-container-md>
  <app-header (closeEvent)="onCloseEvent($event)">
  </app-header>
  <div class="voxel-container-md container-padding">

    <app-stepper 
            *ngIf="CONTENT_BOUNDS && stepsList && stepsList.length > 0" 
            [title]="CONTENT_BOUNDS?.title" 
            [currentStep]="app.channelId=='159'?3:4" 
            [stepsList]="stepsList" 
            [labelName]="CONTENT_BOUNDS?.name" 
            [labelStep]="CONTENT_BOUNDS?.step">
        </app-stepper> 

    <div class="container-data">
      
        <div class="voxel-col-12 voxel-pb-5">
            <voxel-alert  id="sample" [type]="CONTENT_BOUNDS?.notification?.type" light class="voxel-mb-2" [icon]="CONTENT_BOUNDS?.notification?.icon" autoFocus >
              {{CONTENT_BOUNDS?.notification?.label}}
            </voxel-alert>
            <voxel-alert *ngIf="isErrorUpload" id="files-error" [type]="CONTENT_BOUNDS?.notification_error_upload?.type" light class="voxel-mb-2" [icon]="CONTENT_BOUNDS?.notification_error_upload?.icon" autoFocus >
              {{CONTENT_BOUNDS?.notification_error_upload?.caption}} <button voxelButtonAction (click)="processAction(CONTENT_BOUNDS?.notification_error_upload?.caption_link?.action)">{{CONTENT_BOUNDS?.notification_error_upload?.caption_link?.label}} </button>
            </voxel-alert>
          </div>
          <div class="voxel-col-12 voxel-pb-3">
            <div class="border voxel-border-color-soft voxel-pv-5 voxel-border voxel-border voxel-border-radius-layout-01">
              <div class="voxel-text-insight-bold voxel-pl-5">{{CONTENT_BOUNDS?.notification?.caption}}
                <span class="voxel-text-insight-bold" [innerText]="RADICATION_ID_CODE"></span>
                <p class="caption-subtitle">{{CONTENT_BOUNDS?.notification?.caption_subtitle}}</p>
              </div>
            </div>
            
          </div>
          <div class="voxel-pv-1">
            <div *ngIf="isVisible('customer_data')">
              <div class="card" *ngIf="CONTENT_BOUNDS?.information_basics; let section">
                <div class="card-title">
                  <h4 class="">{{section.title}}</h4>
                </div>
                <div class="card-content" >
                  <div class="voxel-row readonly-items">
                    <ng-container *ngIf="getValueProperty(solicitationData, 'basicData.document_type')">
                      <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item">
                        <p class="voxel-text-body-01-bold">{{section.identificationType}}</p>
                        <span class="readonly-item-value">{{getValueProperty(solicitationData,'basicData.document_type') | itemName:"id":"name":documentTypeList | unicode}}</span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="getValueProperty(solicitationData, 'basicData.document_number')">
                      <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item">
                        <p class="voxel-text-body-01-bold" [innerText]="section?.identificationNumber"></p>
                        <span class="readonly-item-value">{{getValueProperty(solicitationData,'basicData.document_number','')}}</span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="getValueProperty(solicitationData, 'basicData.client_names')">
                      <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item">
                        <p class="voxel-text-body-01-bold">{{section?.customerName}}</p>
                        <span class="readonly-item-value">{{getValueProperty(solicitationData, 'basicData.client_names','')}}
                        {{getValueProperty(solicitationData,'basicData.client_surnames','')}}</span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="getValueProperty(solicitationData, 'basicData.city')">
                      <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item">
                        <p class="voxel-text-body-01-bold">{{section?.city}}</p>
                        <span class="readonly-item-value">{{getValueProperty(solicitationData, 'basicData.city') | itemName:"id":"name":citiesList }}</span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="getValueProperty(solicitationData, 'basicData.address')">
                      <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item">
                        <p class="voxel-text-body-01-bold">{{section?.address}}</p>
                        <span class="readonly-item-value">{{getValueProperty(solicitationData,'basicData.address','')}}</span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="getValueProperty(solicitationData, 'basicData.economic_activity')">
                      <div *ngIf="getValueProperty(solicitationData, 'basicData.economic_activity', false)" class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item">
                        <p class="voxel-text-body-01-bold">{{section?.finantialActivity}}</p>
                        <span class="readonly-item-value">{{getValueProperty(solicitationData, 'basicData.economic_activity') | itemName:"id":"name":finantialsList }}</span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="getValueProperty(solicitationData, 'basicData.segment')">
                      <div *ngIf="getValueProperty(solicitationData, 'basicData.segment', false)" class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item">
                        <p class="voxel-text-body-01-bold">{{section?.segment}}</p>
                        <span class="readonly-item-value">{{getValueProperty(solicitationData, 'basicData.segment') | itemName:"id":"name":segmentsList }}</span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="getValueProperty(solicitationData, 'basicData.subsegment')">
                      <div *ngIf="getValueProperty(solicitationData, 'basicData.subsegment', false)" class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item">
                        <p class="voxel-text-body-01-bold">{{section?.subSegment}}</p>
                        <span class="readonly-item-value">{{getValueProperty(solicitationData, 'basicData.subsegment') | itemName:"id":"name":subsegmentList }}</span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="getValueProperty(solicitationData, 'basicData.gender')">
                      <div *ngIf="getValueProperty(solicitationData, 'basicData.customer_exists', false)" class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item">
                        <div *ngIf="getValueProperty(solicitationData, 'basicData.gender')!==not_preset_gender">
                          <p class="voxel-text-body-01-bold" [textContent]="section?.gender.label"></p>
                          <span class="readonly-item-value" [textContent]="getValueProperty(solicitationData, 'basicData.gender') | itemName:'id':'name':genderList"></span>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="voxel-pv-1">
            <div>
              <div class="card" *ngIf="this.CONTENT_BOUNDS?.information_details let section">
                <div class="card-title">
                  <h4 class="">{{section.title}}</h4>
                  <div class="card-title-actions">
                  </div>
                </div>
                <div class="card-content">
                  <div class="voxel-row readonly-items">
                    
                    <div class="voxel-col-3 voxel-col-sm-4 voxel-col-md-6 readonly-item">
                      <p class="voxel-text-body-01-bold" [innerText]="section?.solicitationType"></p>
                      <span class="voxel-text-body-01"
                        [textContent]="getValueProperty(solicitationData,'additionalData.SolicitationType','')|itemName:'id':'name':celulaTypesList"></span>
                    </div>
                    <div class="voxel-col-3 voxel-col-sm-4 voxel-col-md-6 readonly-item">
                      <p class="voxel-text-body-01-bold">{{section?.solicitationSubType}}</p>
                      <span class="voxel-text-body-01"
                        [textContent]="getValueProperty(solicitationData,'additionalData.SolicitationSubtype','')|itemName:'id':'name':celulaSubtypesList"></span>
                    </div>
                    <div class="voxel-col-12">
                      <div class="voxel-col-12" *ngIf="getValueProperty(solicitationData,'additionalData.additional_data', []).length>0">
                        <p class="voxel-col-12 voxel-text-body-01-bold">{{section?.supports}}</p>
                        <div class="voxel-row">
                          <voxel-list class="voxel-col-12">
                            <li voxelListColumn *ngFor="let fileItem of solicitationData?.additionalData?.additional_data || []; let i = index;">
                              <voxel-list-text>
                                <button voxelButtonAction (click)="downloadFile(fileItem.file)">
                                  {{fileItem.file.name}}
                                </button>
                              </voxel-list-text>
                              <voxel-list-descr><em>{{fileItem?.file?.size|fileSize}}</em>
                              </voxel-list-descr>
                            </li>
                          </voxel-list>
                        </div>
                      </div>
                      <div class="voxel-col-12" *ngIf="getValueProperty(solicitationData, 'additionalData.Annotations', false)">
                        <p class="voxel-col-12 voxel-text-body-01-bold" [textContent]="section?.annotations??''"></p>
                        <span class="voxel-col-12 span-text"
                          [innerText]="getValueProperty(solicitationData, 'additionalData.Annotations')"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <div class="actions">
          <div class="voxel-row">
              <button
                  voxelButton
                  buttonStyle="secondary"
                  size=""
                  (click)="navigateTo('previous')"
                  class="voxel-col-12 voxel-col-xs-2 voxel-col-offset-sm-2 voxel-col-sm-3 voxel-col-offset-md-3 voxel-col-md-4">
                  {{CONTENT_BOUNDS?.buttons?.secondary_button.caption}}
              </button>
              <button
                  voxelButton
                  (click)="navigateTo('next')"
                  class="voxel-col-12 voxel-col-xs-2 voxel-col-sm-3 voxel-col-md-4">
                  {{CONTENT_BOUNDS?.buttons?.primary_button.caption}}
              </button>
          </div>
      </div>
  </div>
</voxel-container-md>
